<p class="heading-title">Group Criteria</p>
<div class="desc-and-img-panel">
  <div class="desc-panel">
    <p class="group-criteria-description">
      Group criteria are used to show three status types. If no criteria are
      selected, only the "Member meets all criteria" status will be shown.
    </p>
  </div>
  <div class="img-panel">
    <group-criteria-description-images></group-criteria-description-images>
  </div>
</div>
<div class="set-and-display-criteria">
  <div class="set-criteria" *ngIf="!group.isSharedWithMe">
    <set-group-criteria
      [group]="group"
      [columns]="columns"
      (addCriteria)="addCriteria.emit($event)"
    ></set-group-criteria>
  </div>
  <div class="display-criteria">
    <display-group-criteria
      [columns]="columns"
      [filters]="group.efficacyCriteria"
      [isAddGroup]="isAddGroup"
      [isSharedWithMe]="group.isSharedWithMe"
      (deleteCriteria)="deleteCriteria.emit($event)"
    ></display-group-criteria>
  </div>
</div>
